// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps} from '../../../constants'

const actionGetStories = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_STORIES),
  api: api.getStories,
  payload: { data: new URLSearchParams(payload).toString() },
  callback,
});
const actionGetCategories = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_CATEGORIES),
  api: api.getCategories,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

const actionGetStoryDetail = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: new URLSearchParams(payload).toString() },
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryDetail,
  callback,
});

const actionGetStoryPages = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryPages,
  payload: { data: new URLSearchParams(payload) },
  callback,
});


export {
  actionGetStories,
  actionGetCategories,
  actionGetStoryPages,
  actionGetStoryDetail
};